import { Visualize3dSettings } from '../models/visualize3d-settings';
import { PointerEventEmitter } from '../view-interactions/pointer-event-emitter';
import { ViewEventHandler } from '../view-interactions/view-event-handler';
import { Vector3 } from 'three';

const globalV3dSettings: Visualize3dSettings = {
  appPointerEventEmitter: PointerEventEmitter,
  appViewEventHandler: ViewEventHandler,

  cameraFov: 45,
  cameraNearPlane: 0.1,
  cameraFarPlane: 1000,
  // Font used for qmodel texts.
  qmodelFontUrl: 'assets/font_helvetiker_regular_typeface.json',
  qmodelFontSegmentQuality: 3,

  upVector: new Vector3(0, 0, 1),
  debug: false,
  showDebugStats: false,
  showDebugAxes: false,
  maxIdleFps: 10,
};

export { globalV3dSettings };
